import React from 'react';
import Image from "./Image";
export var IconTypes;
(function (IconTypes) {
    IconTypes["ADD_GRAY"] = "glyphs/add_gray.svg";
    IconTypes["ANDROID_BLUE"] = "android_blue.svg";
    IconTypes["ANDROID_COLOR"] = "android_color.svg";
    IconTypes["ANDROID_GRAY"] = "android_gray.svg";
    IconTypes["APPHUB_LOGO"] = "appHub_logo.png";
    IconTypes["APP_STORE_ICON"] = "app_store.png";
    IconTypes["DELETE_ICON"] = "delete.svg";
    IconTypes["EXTERNAL_SITE_ICON"] = "external_website.svg";
    IconTypes["FIREOS_BLUE"] = "fireos_blue.svg";
    IconTypes["FIREOS_GRAY"] = "fireos_gray.svg";
    IconTypes["GALAXY_STORE_ICON"] = "galaxy_store.svg";
    IconTypes["IOS_BLUE"] = "ios_blue.svg";
    IconTypes["IOS_COLOR"] = "ios_color.svg";
    IconTypes["IOS_GRAY"] = "ios_gray.svg";
    IconTypes["MEDIATION_EXPERIMENT"] = "mediation_experiment.svg";
    IconTypes["MORE_ICON"] = "more.svg";
    IconTypes["NO_APP_ICON"] = "no_app_icon.svg";
    IconTypes["NO_EVENTS"] = "no-events.svg";
    IconTypes["PAUSE_ICON"] = "pause.svg";
    IconTypes["PLAY_GRAY_ICON"] = "play_gray.svg";
    IconTypes["PLAY_STORE_ICON"] = "play_store.svg";
    IconTypes["REWARDED_INTERSTITIALS"] = "rewarded_interstitials.svg";
    IconTypes["UI_ARROW_LEFT"] = "ui_arrow_left.svg";
    IconTypes["UI_ARROW_RIGHT"] = "ui_arrow_right.svg";
    IconTypes["UI_CROSS_ICON"] = "glyphs/close_gray.svg";
})(IconTypes || (IconTypes = {}));
const Icon = (props) => {
    const imageUrl = require(`../assets/images/${props.iconType}`);
    return React.createElement(Image, { src: imageUrl, ...props });
};
export default Icon;
//# sourceMappingURL=Icon.js.map